// extracted by mini-css-extract-plugin
module.exports = {"calendar":"dateitem_calendar__ctdAP","wrapper":"dateitem_wrapper__2wnro","currWrap":"dateitem_currWrap__3zbQ0"};